import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { common_axios } from "../../../../App";
import { toast, ToastContainer } from "react-toastify";
import CheckBox from "../../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableViewIcon from "@mui/icons-material/TableView";
import {
  Backdrop,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import Loader from "../../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";
import { dateFormatter } from "../../../../helper/helper";
import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PersonIcon from "@mui/icons-material/Person";
import Swal from "sweetalert2";
import RefreshIcon from "@mui/icons-material/Refresh";
import InfoIcon from "@mui/icons-material/Info";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Pagination from "@mui/material/Pagination";
import {
  Stack,
} from "@mui/material";
export default function TransactionalCardsReports() {
  // .....................................................Scroll Bar.................................................................//
  const wrapper1Ref = useRef(null);
  const wrapper2Ref = useRef(null);
  const div1Ref = useRef(null);
  const div2Ref = useRef(null);

  const handleWrapper1Scroll = (e) => {
    wrapper2Ref.current.scrollLeft = wrapper1Ref.current.scrollLeft;
  };

  const handleWrapper2Scroll = (e) => {
    wrapper1Ref.current.scrollLeft = wrapper2Ref.current.scrollLeft;
  };

  const updateDivWidths = () => {
    if (div1Ref.current && div2Ref.current) {
      div1Ref.current.style.width =
        div2Ref.current.querySelector("table").offsetWidth + "px";
      div2Ref.current.style.width =
        div2Ref.current.querySelector("table").offsetWidth + "px";
    }
  };

  // ..................................................End Of Scroll Bar..............................................................//
  const [paginationPage, setPaginationPage] = React.useState(1);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);

  const [Status, setStatus] = useState({
    approveType: "Completed",
    resellerName: null,
    type: null,
    approveAssignedType: null,
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
    selectorType: null,
  });

  const customId1 = "custom-id-yes";

  const fetchUser = async () => {
    try {
      setOpen(true);

      const res1 = common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/multiline/graph/event-name`,
        {
          campaignRequest: {
            startDateTime: localStorage.getItem("dstQueCode1")?.split(",")?.[0],
            endDateTime: localStorage.getItem("dstQueCode1")?.split(",")?.[0],
          },
          scheduledStatus: localStorage.getItem("dstQueCode1")?.split(",")?.[1],
          // eventName: Status.resellerName,
          pageNo: Status?.pageNo,
          pageSize: Status?.pageSize,
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
        }
      );

      await Promise.all([res1]).then((values) => {
        console.log({ values });

        if (values[0].data.statusDescription.statusCode == 200) {
          setData2({
            eventNames: values?.[0]?.data?.eventName,
          });

          setOpen(false);
        } else {
          setOpen(false);
          // toast.error(values[0].data.statusDescription.statusMessage, {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: values[0].data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      });
    } catch (error) {
      setOpen(false);
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // useEffect(async () => {
  //   fetchUser();
  // }, [Status?.approveType]);

  const fetchUserr = async () => {
    if (Status.resellerName || Status.type) {
      try {
        setOpen(true);

        let url;
        if (
          localStorage.getItem("dstQueCode1")?.split(",")?.[1] == "campaign"
        ) {
          url = "sms/dashboard/table/v1/find/campaign/by/event-name";
        } else {
          url = "sms/dashboard/table/v1/find/success/or/failed";
        }

        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/${url}`,
          {
            campaignRequest: {
              startDateTime: localStorage
                .getItem("dstQueCode1")
                ?.split(",")?.[3],
              endDateTime: localStorage.getItem("dstQueCode1")?.split(",")?.[2],
            },
            pageNo: Status?.pageNo,
            pageSize: Status?.pageSize,
            approved:
              localStorage.getItem("dstQueCode1")?.split(",")?.[1] == "failedM"
                ? "Failed"
                : "Success",
            eventName:
              Status.resellerName == null || Status.resellerName == ""
                ? null
                : Status.resellerName,
            msisdn:
              Status.resellerName == null || Status.resellerName == ""
                ? null
                : Status.resellerName,
            category: Status.type,
            role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
            flag: localStorage.getItem("dstQueCode1")?.split(",")?.[0],
          }
        );

        if (res.data?.statusDescription?.statusCode == 200) {
          if (
            localStorage.getItem("dstQueCode1")?.split(",")?.[1] == "campaign"
          ) {
            setData1(res.data?.playSmsOutgoingQueueData);
            setData(res.data?.playSmsOutgoingQueueData?.content);
          } else {
            setData1(res.data?.playsms_tblSMSOutgoing);
            setData(res.data?.playsms_tblSMSOutgoing?.content);
          }

          setOpen(false);
        } else if (res.data?.statusDescription?.statusCode == 220) {
          setData([]);
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        setOpen(false);
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } else {
      setData([]);
      try {
        setOpen(true);

        let url;
        if (
          localStorage.getItem("dstQueCode1")?.split(",")?.[1] == "campaign"
        ) {
          url = "sms/dashboard/table/v1/get/cards/total/campaigns";
        } else if (
          localStorage.getItem("dstQueCode1")?.split(",")?.[1] == "successM"
        ) {
          url = "sms/dashboard/table/v1/get/cards/total/success";
        } else {
          url = "sms/dashboard/table/v1/get/cards/total/failed";
        }

        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/${url}`,
          {
            campaignRequest: {
              startDateTime: localStorage
                .getItem("dstQueCode1")
                ?.split(",")?.[3],
              endDateTime: localStorage.getItem("dstQueCode1")?.split(",")?.[2],
            },

            // eventName: Status.resellerName,
            pageNo: Status?.pageNo,
            pageSize: Status?.pageSize,
            role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
            flag: localStorage.getItem("dstQueCode1")?.split(",")?.[0],
          }
        );

        if (res.data?.statusDescription?.statusCode == 200) {
          if (
            localStorage.getItem("dstQueCode1")?.split(",")?.[1] == "campaign"
          ) {
            if (
              JSON.parse(localStorage.getItem("Sidebaritems")).name ==
              "ROLE_SUPER_ADMIN"
            ) {
              for (
                let index = 0;
                index < res.data.playSmsOutgoingQueueData?.content?.length;
                index++
              ) {
                res.data.playSmsOutgoingQueueData.content[index][`Show`] = true;
                // arr.push(obj);
              }
              setData1(res.data?.playSmsOutgoingQueueData);
              setData(res.data?.playSmsOutgoingQueueData?.content);
            } else {
              setData1(res.data?.playSmsOutgoingQueueData);
              setData(res.data?.playSmsOutgoingQueueData?.content);
            }
          } else if (
            localStorage.getItem("dstQueCode1")?.split(",")?.[1] == "successM"
          ) {
            for (
              let index = 0;
              index < res.data.playsms_tblSMSOutgoing?.content?.length;
              index++
            ) {
              res.data.playsms_tblSMSOutgoing.content[index][`Show`] = true;
              // arr.push(obj);
            }
            setData1(res.data?.playsms_tblSMSOutgoing);
            setData(res.data?.playsms_tblSMSOutgoing?.content);
          } else {
            setData1(res.data?.playsms_tblSMSOutgoing);
            setData(res.data?.playsms_tblSMSOutgoing?.content);
          }

          setOpen(false);
        } else if (res.data?.statusDescription?.statusCode == 220) {
          setData([]);
          setOpen(false);
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        setOpen(false);
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  };

  useEffect(async () => {
    fetchUserr();
  }, [Status.approveType, Status.pageNo, Status.pageSize]);

  // ...................................................Refresh Button Api............................................................//

  async function RefreshBtn(values) {
    setData([]);
    setOpen(true);
    try {
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/cards/total/campaigns`,
        {
          campaignRequest: {
            startDateTime: localStorage.getItem("dstQueCode1")?.split(",")?.[3],
            endDateTime: localStorage.getItem("dstQueCode1")?.split(",")?.[2],
          },

          // eventName: Status.resellerName,
          pageNo: Status?.pageNo,
          pageSize: Status?.pageSize,
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          flag: localStorage.getItem("dstQueCode1")?.split(",")?.[0],
        }
      );

      if (res.data?.statusDescription?.statusCode == 200) {
        setData1(res.data?.playSmsOutgoingQueueData);
        setData(res.data?.playSmsOutgoingQueueData?.content);
        setOpen(false);
        setStatus({
          ...Status,
          resellerName: null,
          hideShow: false,
        });
        // fetchUser();
      } else if (res.data?.statusDescription?.statusCode == 220) {
        setData([]);
        setOpen(false);
        // await toast.error(res.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        // await toast.error(res.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  // ................................................................................................................................../

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  useEffect(() => {
    setStatus({
      ...Status,
      resellerName: null,
    });
  }, [Status.approveType]);

  const columns = useMemo(
    () =>
      localStorage.getItem("dstQueCode1")?.split(",")?.[1] == "campaign" &&
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
        "ROLE_SUPER_ADMIN"
        ? [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => {
                // console.log("cell--", cell.row.index);
                return (
                  <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
                );
              },
            },
            {
              Header: "Event name",

              accessor: "event_Name",
              Cell: (cell) => {
                return (
                  <>
                    <Link
                      onClick={() => {
                        localStorage.setItem(
                          "dstQueCode",
                          `${cell.row.original.queue_code},${cell.row.original.id}`
                        );
                      }}
                      style={{
                        textDecoration: "underline",
                        // color: "blue",
                        fontWeight: "bolder",
                      }}
                      to={`/dashboard/DashboardReportss/All`}
                    >
                      {cell.row.original.event_Name}
                    </Link>
                    <div className="my-2 fw-bold" style={{ color: "#959595" }}>
                      {`(${cell?.row?.original?.username})`}
                    </div>
                  </>
                );
              },
            },

            {
              Header: "Start Date Time",

              accessor: "datetime_Scheduled", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_Scheduled
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "End Date Time",

              accessor: "datetime_End", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_End
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "Sender Id",

              accessor: "sender_Id", // accessor is the "key" in the data
            },

            {
              Header: "Total sms",

              accessor: "sms_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.success_Count?.toLocaleString("en-IN")}
                  </>
                );
              },
            },
            {
              Header: "Sms Success",

              accessor: "success_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.sms_Count?.toLocaleString("en-IN")}</>
                );
              },
            },
            {
              Header: "Sms Fail",

              accessor: "fail_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.fail_Count?.toLocaleString("en-IN")}</>
                );
              },
            },
            {
              Header: "Camp Type",

              accessor: "sms_Type", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.sms_Type == "Promotional" ? (
                      <div className="">P</div>
                    ) : (
                      <div className="">T</div>
                    )}
                  </>
                );
              },
            },

            {
              Header: "Message",
              accessor: "message", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.message.length >= 60 ? (
                      <div className="">
                        <div className="showMoreTd">
                          {cell.row.original?.[`Show`]
                            ? cell.row.original.message?.slice(0, 60) + "..."
                            : cell.row.original.message}
                        </div>
                        <button
                          className="showMore"
                          onClick={() => {
                            // Showdata?.[`Show${cell.row.index}`];
      
                            const dataaa = [...data];
      
                            dataaa[cell.row.index][`Show`] =
                              !cell.row.original?.[`Show`];
      
                            setData(dataaa);
                          }}
                        >
                          {cell.row.original?.[`Show`] ? "More" : "Less"}
                        </button>
                      </div>
                    ) : (
                      <div className="showMoreTd">{cell.row.original.message}</div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Status",

              accessor: "status",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.scheduled_Status == 6 ? (
                      <div className="badge badge_8 bg-success activated_1">
                        Completed
                      </div>
                    ) : (
                      <div className="badge badge_8 bg-danger activated_1">
                        Stopped
                      </div>
                    )}
                  </>
                );
              },
            },
          ]
        : localStorage.getItem("dstQueCode1")?.split(",")?.[1] == "campaign" &&
          JSON.parse(localStorage.getItem("Sidebaritems")).name == "ROLE_USER"
        ? [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => {
                // console.log("cell--", cell.row.index);
                return (
                  <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
                );
              },
            },
            {
              Header: "Event name",

              accessor: "event_Name",
              Cell: (cell) => {
                return (
                  <Link
                    onClick={() => {
                      localStorage.setItem(
                        "dstQueCode",
                        `${cell.row.original.queuecode},${cell.row.original.id}`
                      );
                    }}
                    style={{
                      textDecoration: "underline",
                      // color: "blue",
                      fontWeight: "bolder",
                    }}
                    to={`/dashboard/DashboardReportss/All`}
                  >
                    {cell.row.original.event_Name}
                  </Link>
                );
              },
            },

            {
              Header: "Start Date Time",

              accessor: "datetime_Scheduled", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_Scheduled
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "End Date Time",

              accessor: "datetime_End", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.datetime_End
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span>{dataaa}</span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            {
              Header: "Sender Id",

              accessor: "sender_Id", // accessor is the "key" in the data
            },

            {
              Header: "Camp Type",

              accessor: "sms_Type", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.sms_Type == "Promotional" ? (
                      <div className="">P</div>
                    ) : (
                      <div className="">T</div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Message",
              accessor: "message", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.message.length >= 60 ? (
                      <div className="">
                        <div className="showMoreTd">
                          {cell.row.original?.[`Show`]
                            ? cell.row.original.message?.slice(0, 60) + "..."
                            : cell.row.original.message}
                        </div>
                        <button
                          className="showMore"
                          onClick={() => {
                            // Showdata?.[`Show${cell.row.index}`];
      
                            const dataaa = [...data];
      
                            dataaa[cell.row.index][`Show`] =
                              !cell.row.original?.[`Show`];
      
                            setData(dataaa);
                          }}
                        >
                          {cell.row.original?.[`Show`] ? "More" : "Less"}
                        </button>
                      </div>
                    ) : (
                      <div className="showMoreTd">{cell.row.original.message}</div>
                    )}
                  </>
                );
              },
            },

            {
              Header: "Total Sms",

              accessor: "sms_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.sms_Count?.toLocaleString("en-IN")}</>
                );
              },
            },
            {
              Header: "Sms Success",

              accessor: "success_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.success_Count?.toLocaleString("en-IN")}
                  </>
                );
              },
            },
            {
              Header: "Sms Fail",

              accessor: "fail_Count", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>{cell.row.original.fail_Count?.toLocaleString("en-IN")}</>
                );
              },
            },
            {
              Header: "Status",

              accessor: "status",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.scheduled_Status == 6 ? (
                      <div className="badge badge_8 bg-success activated_1">
                        Completed
                      </div>
                    ) : (
                      <div className="badge badge_8 bg-danger activated_1">
                        Stopped
                      </div>
                    )}
                  </>
                );
              },
            },
          ]
        : [
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => {
                // console.log("cell--", cell.row.index);
                return (
                  <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
                );
              },
            },
            {
              Header: "Mobile Number",

              accessor: "dst",
            },
            {
              Header: "Created Date Time",

              accessor: "pDatetime", // accessor is the "key" in the data
              // Cell: (cell) => {
              //   return <>{dateFormatter(cell.row.original.ctimestamp)}</>;
              // },
            },
            {
              Header: "End Date Time",

              accessor: "pupdate", // accessor is the "key" in the data
              // Cell: (cell) => {
              //   return <>{dateFormatter(cell.row.original.pupdate)}</>;
              // },
            },
            {
              Header: "Sender Id",

              accessor: "psrc", // accessor is the "key" in the data
            },

            {
              Header: "Camp Type",

              accessor: "psmsType", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.psmsType == "Promotional " ? (
                      <div className="">P</div>
                    ) : (
                      <div className="">T</div>
                    )}
                  </>
                );
              },
            },
            // {
            //   Header: "Message",

            //   accessor: "pmsg", // accessor is the "key" in the data
            // },


            {
              Header: "Message",
              accessor: "pmsg", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.pmsg.length >= 60 ? (
                      <div className="">
                        <div className="showMoreTd">
                          {cell.row.original?.[`Show`]
                            ? cell.row.original.pmsg?.slice(0, 60) + "..."
                            : cell.row.original.pmsg}
                        </div>
                        <button
                          className="showMore"
                          onClick={() => {
                            // Showdata?.[`Show${cell.row.index}`];
      
                            const dataaa = [...data];
      
                            dataaa[cell.row.index][`Show`] =
                              !cell.row.original?.[`Show`];
      
                            setData(dataaa);
                          }}
                        >
                          {cell.row.original?.[`Show`] ? "More" : "Less"}
                        </button>
                      </div>
                    ) : (
                      <div className="showMoreTd">{cell.row.original.pmsg}</div>
                    )}
                  </>
                );
              },
            },

         

            // {
            //   Header: "SMS count",

            //   accessor: "smsCount", // accessor is the "key" in the data
            // },

            {
              Header: "Status",

              accessor: "pStatus",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.pStatus == 3 ? (
                      <div className="badge badge_8 bg-success activated_1">
                        Success{" "}
                      </div>
                    ) : (
                      <div className="badge badge_8 bg-danger activated_1">
                        Failed
                      </div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Status",
              accessor: "log",
            },
          ],
    [Status, data]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data: data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const viewRefModal = useRef(null);

  const deletUser = () => {
    console.log({ selectedFlatRows });
  };
  // ..........................................ScrollBar Useefffect.......................
  useEffect(() => {
    if (wrapper1Ref.current && wrapper2Ref.current) {
      wrapper1Ref.current.addEventListener("scroll", handleWrapper1Scroll);
      wrapper2Ref.current.addEventListener("scroll", handleWrapper2Scroll);
    }
    updateDivWidths();
    window.addEventListener("resize", updateDivWidths);
    return () => {
      window.removeEventListener("resize", updateDivWidths);
    };
  }, [wrapper1Ref, wrapper2Ref, div1Ref, div2Ref, data]);

  // ............................................End.........................//
  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <PersonIcon
                style={{
                  color: "white",
                  fontSize: "27px",
                }}
              />
            </div>
            <div style={{ marginLeft: "6rem" }}>
              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                {localStorage.getItem("dstQueCode1")?.split(",")?.[1] ==
                "campaign"
                  ? "Campaign Report"
                  : localStorage.getItem("dstQueCode1")?.split(",")?.[1] ==
                    "failedM"
                  ? "Failed Message Report"
                  : "Success Message Report"}
              </p>
            </div>
          </div>

          <div className="card-body pt-0">
            {data?.length > 0 ? (
              <>
                {/* {Status.hideShow && ( */}
                <>
                  <div
                    className="d-flex justify-content-between my-3"
                    style={{ minHeight: "4rem", maxHeight: "4rem" }}
                  >
                    <div className=" my-auto">
                      <div className="d-flex ">
                        <div className="my-auto">
                          <select
                            value={Status.pageSize}
                            className="dropdown p-2"
                            onChange={(e) => {
                              setPageSize(Number(e.target.value));
                              setStatus({
                                ...Status,
                                pageSize: e.target.value,
                              });
                            }}
                          >
                            {[10, 25, 50].map((value, i) => {
                              return (
                                <option
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton1"
                                  value={value}
                                  key={value}
                                >
                                  Show {value}
                                </option>
                              );
                            })}
                          </select>
                        </div>

                        <div className="my-auto ms-3">
                          <div className="text-end" style={{ flexGrow: "1" }}>
                            <IconButton
                              variant="text"
                              size="small"
                              sx={{
                                color: "#7B809A",
                              }}
                              onClick={(event) => {
                                setStatus({
                                  ...Status,
                                  hideShow: !Status.hideShow,
                                });
                              }}
                            >
                              {Status.hideShow ? (
                                <CancelIcon />
                              ) : (
                                <SearchIcon />
                              )}
                            </IconButton>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-auto">
                      <div className="d-flex flex-wrap justify-content-between my-3">
                        {Status.hideShow && (
                          <>
                            <div
                              className="d-flex me-3"
                              style={{ width: "200px" }}
                            >
                              <FormControl fullWidth>
                                <InputLabel size="small" id="test-select-label">
                                  Select Search Category
                                </InputLabel>
                                <Select
                                  size="small"
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={Status.selectorType}
                                  label="Select Search Category"
                                  onChange={(e) => {
                                    setStatus({
                                      ...Status,
                                      selectorType: e.target.value,
                                    });
                                  }}
                                >
                                  {[
                                    localStorage
                                      .getItem("dstQueCode1")
                                      ?.split(",")?.[1] == "campaign" && {
                                      id: 0,
                                      name: "Event Name",
                                      value: "Event Name",
                                    },
                                    localStorage
                                      .getItem("dstQueCode1")
                                      ?.split(",")?.[1] != "campaign" && {
                                      id: 1,
                                      name: "Mobile Number",
                                      value: "Mobile Number",
                                    },
                                    {
                                      id: 2,
                                      name: "Type",
                                      value: "Type",
                                    },
                                  ].map((d) => {
                                    return (
                                      <MenuItem key={d.id} value={d.value}>
                                        {" "}
                                        {d.name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </div>

                            <div className="d-flex">
                              {Status.selectorType == "Mobile Number" ||
                              Status.selectorType == "Event Name" ? (
                                <TextField
                                  required
                                  className="w-100 me-3"
                                  label={
                                    Status.selectorType == "Mobile Number"
                                      ? "Enter Mobile Number"
                                      : "Event Name"
                                  }
                                  name="senderId"
                                  variant="outlined"
                                  size="small"
                                  type="text"
                                  value={Status.resellerName}
                                  onChange={(e) => {
                                    setStatus({
                                      ...Status,
                                      type: null,
                                      resellerName: e.target.value,
                                    });
                                  }}
                                />
                              ) : null}

                              {/* <div className="d-flex justify-content-between">
                  <select
                    // style={{ height: "100%", borderRadius: "5px" }}
                    className="dropdown"
                    required
                    value={Status.type}
                    onChange={(e) => {
                      setStatus({
                        ...Status,
                        type: e.target.value,
                      });
                    }}
                    name="selectValue"
                  >
                    {[
                      { id: 0, name: "All", value: "" },
                      { id: 1, name: "Promotional", value: "Promotional" },
                      { id: 2, name: "Transactional", value: "Transactional" },
                    ].map((d) => {
                      return (
                        <option className="dropdown-menu" value={d.value}>
                          {d.name}
                        </option>
                      );
                    })}
                  </select>
                </div> */}

                              {Status.selectorType == "Type" ? (
                                <div
                                  className="d-flex justify-content-between mx-3"
                                  style={{ width: "300px" }}
                                >
                                  <FormControl fullWidth>
                                    <InputLabel
                                      size="small"
                                      id="test-select-label"
                                    >
                                      Select Type
                                    </InputLabel>
                                    <Select
                                      size="small"
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={Status.type}
                                      label="Select Type"
                                      onChange={(e) => {
                                        setStatus({
                                          ...Status,
                                          resellerName: "",
                                          type: e.target.value,
                                        });
                                      }}
                                    >
                                      {[
                                        { id: 0, name: "All", value: null },
                                        {
                                          id: 1,
                                          name: "Promotional",
                                          value: "Promotional",
                                        },
                                        {
                                          id: 2,
                                          name: "Transactional",
                                          value: "Transactional",
                                        },
                                      ].map((d) => {
                                        return (
                                          <MenuItem value={d.value}>
                                            {" "}
                                            {d.name}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                </div>
                              ) : null}

                              <div className="d-flex justify-content-between">
                                <button
                                  disabled={
                                    Status.type == null &&
                                    (Status.resellerName == null ||
                                      Status.resellerName == "")
                                  }
                                  onClick={fetchUserr}
                                  className={
                                    Status.type == null &&
                                    (Status.resellerName == null ||
                                      Status.resellerName == "")
                                      ? "btn btn-secondary"
                                      : "btn btn-primary"
                                  }
                                >
                                  <FilterAltIcon />
                                </button>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="my-auto"></div>

                    {/* <Tooltip title="Refresh">
                    <button
                      type="submit"
                      className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                      onClick={() => RefreshBtn("Text to Copy")}
                    >
                      <RefreshIcon />
                    </button>
                  </Tooltip> */}

                    {/* <TextField
                        className="ms-4"
                        style={{
                          borderRadius: "4px",
                        }}
                        type="text"
                        label="Search"
                        name="Search"
                        variant="outlined"
                        // value={number}
                        size="small"
                        value={globalSearchValue || ""}
                        onChange={(e) => {
                          onChange(e.target.value);
                          setGlobalSearchValue(e.target.value);
                        }}
                      /> */}
                  </div>
                </>
                {/* )} */}

                <div className="text-end">
                  {selectedFlatRows.length > 0 && (
                    <button
                      onClick={deletUser}
                      className="btn bg-gradient-primary m-0"
                    >
                      Delete Users
                    </button>
                  )}
                </div>

                {data && data?.length > 0 && (
                  <div className="table-responsive">
                    {/* <div class="wrapper1" ref={wrapper1Ref}>
                        <div class="div1" ref={div1Ref}>
                        <table
                      {...getTableProps()}
                      id="example"
                      className="table table-striped message_table table-bordered dataTable table-sm mt-3"
                      style={{ width: "100%" }}
                    >
                      <thead className="teble_scroll">
                        {headerGroups.map((headerGroup) => (
                          <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                              <th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps()
                                )}
                                className="text-center width_2"
                              >
                                {column.render("Header")}
                                <span>
                                  {column.isSorted
                                    ? column.isSortedDesc
                                      ? "↑"
                                      : "↓"
                                    : ""}
                                </span>
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <tr {...row.getRowProps()}>
                              {row.cells.map((cell) => {
                                return (
                                  <td
                                    {...cell.getCellProps()}
                                    // className="text-left"
                                    className={
                                      cell.column.Header == "Sender Id"
                                        ? "text-end"
                                        : cell.column.Header == "Status" ||
                                          cell.column.Header == "Unicode"
                                        ? "text-center"
                                        : "text-start"
                                    }
                                  >
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                        </div>
                      </div> */}
                    {/* <div class="wrapper2" ref={wrapper2Ref}>
                        <div class="div2" ref={div2Ref}> */}
                    <table
                      {...getTableProps()}
                      id="example"
                      className="table table-striped table-bordered dataTable table-sm mt-3"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        {headerGroups.map((headerGroup) => (
                          <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                              <th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps()
                                )}
                                className={
                                  column?.Header == "Message"
                                    ? "text-center width_2 update_th messageWidth"
                                    : column?.Header == "Camp Type"
                                    ? "text-center width_2 update_th_sp d-flex border-start-0"
                                    : "text-center width_2 update_th_sp"
                                }
                              >
                                {column.render("Header")}
                                <span>
                                  {column.isSorted
                                    ? column.isSortedDesc
                                      ? "↑"
                                      : "↓"
                                    : ""}
                                </span>
                                {column.Header == "Camp Type" ? (
                                  <>
                                    <InputAdornment
                                      position="end"
                                      className="my-auto"
                                    >
                                      {/* {`(${cell?.row?.original?.username})`} */}
                                      <Tooltip
                                        // title={`Promotional-P ${<br/>} Transactional-T`}
                                        // title={`(${Promotional-P})`<br> `(${Promotional-P})`}
                                        title={"P-Promotional T-Transactional"
                                          .split(" ")
                                          .map((arg) => {
                                            return (
                                              <>
                                                {arg}
                                                <br />
                                              </>
                                            );
                                          })}
                                        id="toolTipId"
                                        placement="top"
                                        arrow
                                        sx={{ color: "white" }}
                                      >
                                        <InfoIcon />
                                      </Tooltip>
                                    </InputAdornment>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <tr {...row.getRowProps()}>
                              {row.cells.map((cell) => {
                                return (
                                  <td
                                    {...cell.getCellProps()}
                                    // className="text-left"
                                    // className={
                                    //   cell.column.Header == "Sender Id"
                                    //     ? "text-end"
                                    //     : cell.column.Header == "Status" ||
                                    //       cell.column.Header == "Unicode"
                                    //     ? "text-center"
                                    //     : "text-start"
                                    // }

                                    className={
                                      cell.column.Header == "Sender Id" ||
                                      cell.column.Header == "Total sms" ||
                                      cell.column.Header == "Sms Success" ||
                                      cell.column.Header == "Sms Fail"
                                        ? "text-end update_td"
                                        : cell.column.Header == "Status" ||
                                          cell.column.Header == "Id" ||
                                          cell.column.Header == "Camp Type"
                                        ? "text-center update_td"
                                        : "text-start update_td"
                                    }
                                  >
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {/* </div>
                      </div> */}
                  </div>
                )}

                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <span>
                      Page:
                      <strong>
                        {data1?.pageable?.pageNumber + 1} of {data1?.totalPages}
                      </strong>
                    </span>
                  </div>





                  <div className="prev_next d-flex align-items-center">
                <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      //  disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                       
                        setStatus({
                          ...Status,
                          pageNo:0,
                        });
                        setPaginationPage(1)
                      }}
                    >
                      First
                    </button>

                <Stack spacing={2}>
              <Pagination
                onChange={(event, value) => {
                  console.log("va--", value);
                  setStatus({
                    ...Status,
                    pageNo: Number(value) - 1,
                  });
                  setPaginationPage(value);
                }}
                page={paginationPage}
                count={data1? data1?.totalPages : ""}
               
                variant="outlined"
                shape="rounded"
                
            color="primary"
              />
            </Stack>
            <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      // disabled={
                      //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                      //  }
                      onClick={() => {
                        // alert("gg")
                        setStatus({
                          ...Status,
                          pageNo:data1?.totalPages -1 ,
                        });
                        setPaginationPage(data1?.totalPages)

                      }}
                    >
                      Last
                    </button>
                
              </div>






                  {/* <div>
                    <button
                      className="btn btn_primary "
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo - 1,
                        });
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn_primary ms-2"
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={
                        data1?.totalPages == data1?.pageable?.pageNumber + 1
                      }
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo + 1,
                        });
                      }}
                    >
                      Next
                    </button>
                  </div> */}
                </div>
              </>
            ) : (
              <>
                {data?.length == 0 && open ? null : (
                  <div className="text-center mt-4">
                    <h5>No Record Found..!!</h5>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
